if (!customElements.get('buy-more-save')) {
  class BuyMoreSave extends SwatchInit {
    constructor() {
      super();

      const dataEl = this.querySelector('[data-bms-product]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

      this.tiers = Array.from(this.querySelectorAll('.bms__tier'));
      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.bms__tier-radio');
        radio.addEventListener('change', this.onTierChange.bind(this));
      });

      this.querySelectorAll('.bms__unit-option').forEach((button) => {
        button.addEventListener('click', this.onOptionClick.bind(this));
      });

      this.querySelectorAll('.bms__color-trigger').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleColorDropdown(trigger);
        });
      });

      document.addEventListener('click', () => this.closeAllColorDropdowns());

      this.querySelectorAll('.bms__unit').forEach((unit) => {
        this.updateOptionAvailability(unit);
        this.updateUnit(unit);
        this.syncAllColorTriggers(unit);
      });

      const submit = this.querySelector('.bms__submit');
      if (submit) {
        submit.addEventListener('click', (event) => this.onSubmit(event, false));
      }

      const buyNow = this.querySelector('.bms__buynow');
      if (buyNow) {
        buyNow.addEventListener('click', (event) => this.onSubmit(event, true));
      }
    }

    onTierChange() {
      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.bms__tier-radio');
        const units = tier.querySelector('.bms__units');
        tier.classList.toggle('active', radio.checked);
        if (units) units.hidden = !radio.checked;
      });
      this.clearError();
    }

    onOptionClick(event) {
      const button = event.currentTarget;
      if (button.disabled) return;

      const field = button.closest('.bms__unit-field');
      const unit = button.closest('.bms__unit');
      if (!field || !unit) return;

      field.querySelectorAll('.bms__unit-option').forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      this.updateOptionAvailability(unit);
      this.updateUnit(unit);
      this.syncAllColorTriggers(unit);
      this.closeAllColorDropdowns();
      this.clearError();
    }

    toggleColorDropdown(trigger) {
      const dropdown = trigger.closest('.bms__color-dropdown');
      const panel = dropdown.querySelector('.bms__color-panel');
      const isOpen = !panel.hidden;
      this.closeAllColorDropdowns();
      if (!isOpen) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    closeAllColorDropdowns() {
      this.querySelectorAll('.bms__color-dropdown').forEach((dropdown) => {
        dropdown.querySelector('.bms__color-panel').hidden = true;
        dropdown.querySelector('.bms__color-trigger').setAttribute('aria-expanded', 'false');
      });
    }

    syncAllColorTriggers(unit) {
      unit.querySelectorAll('.bms__unit-field--color').forEach((field) => this.syncColorTrigger(field));
    }

    syncColorTrigger(field) {
      const trigger = field.querySelector('.bms__color-trigger-swatch');
      const label = field.querySelector('.bms__color-trigger-label');
      const active = field.querySelector('.bms__unit-option.active');
      if (!trigger || !active) return;

      trigger.className = 'bms__color-trigger-swatch product__color-swatch rounded-50 relative';
      trigger.removeAttribute('style');
      ['color', 'image', 'customValue', 'swatchType', 'optionSwatchValue'].forEach((key) => {
        if (active.dataset[key] !== undefined) trigger.dataset[key] = active.dataset[key];
      });
      this.checkSwatches(trigger);

      if (label) label.textContent = active.dataset.value;
    }

    getFields(unit) {
      return Array.from(unit.querySelectorAll('.bms__unit-field')).sort(
        (a, b) => a.dataset.optionPosition - b.dataset.optionPosition
      );
    }

    getSelectedValues(unit) {
      return this.getFields(unit).map(
        (field) => field.querySelector('.bms__unit-option.active')?.dataset.value
      );
    }

    // Values available in an option depend on what's already selected in the
    // options before it, so each field is only re-evaluated after the ones
    // ahead of it in the option order have settled on their active value.
    updateOptionAvailability(unit) {
      const fields = this.getFields(unit);

      fields.forEach((field, index) => {
        if (index === 0) return;

        const previousValues = fields
          .slice(0, index)
          .map((f) => f.querySelector('.bms__unit-option.active')?.dataset.value);

        const availableValues = this.variants
          .filter(
            (variant) =>
              variant.available &&
              previousValues.every((value, i) => variant[`option${i + 1}`] === value)
          )
          .map((variant) => variant[`option${index + 1}`]);

        field.querySelectorAll('.bms__unit-option').forEach((button) => {
          const isAvailable = availableValues.includes(button.dataset.value);
          button.classList.toggle('option-disabled', !isAvailable);
          button.disabled = !isAvailable;
          if (!isAvailable) button.classList.remove('active');
        });

        if (!field.querySelector('.bms__unit-option.active')) {
          const firstAvailable = field.querySelector('.bms__unit-option:not(.option-disabled)');
          if (firstAvailable) firstAvailable.classList.add('active');
        }
      });
    }

    updateUnit(unit) {
      const selectedValues = this.getSelectedValues(unit);
      const variant = this.variants.find(
        (candidate) =>
          candidate.available &&
          selectedValues.every((value, index) => candidate[`option${index + 1}`] === value)
      );

      const input = unit.querySelector('.bms__unit-variant-id');
      const image = unit.querySelector('.bms__unit-thumb img');

      if (input) input.value = variant ? variant.id : '';

      if (variant && image && variant.featured_image && variant.featured_image.src) {
        image.src = variant.featured_image.src;
      }
    }

    showError(message) {
      const error = this.querySelector('.bms__error');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    clearError() {
      const error = this.querySelector('.bms__error');
      if (error) error.hidden = true;
    }

    onSubmit(event, redirectToCheckout) {
      event.preventDefault();
      this.clearError();

      const activeTier = this.querySelector('.bms__tier.active');
      if (!activeTier) return;

      const units = Array.from(activeTier.querySelectorAll('.bms__unit'));
      const unavailableUnit = units.some(
        (unit) => !unit.querySelector('.bms__unit-variant-id').value
      );

      if (unavailableUnit) {
        this.showError(
          window.variantStrings?.soldOut || 'One of the selected options is out of stock.'
        );
        return;
      }

      const items = units
        .map((unit) => unit.querySelector('.bms__unit-variant-id').value)
        .filter(Boolean)
        .map((id) => ({ id: parseInt(id, 10), quantity: 1 }));

      if (!items.length) return;

      const button = event.currentTarget;
      button.classList.add('loading');
      button.disabled = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };
      if (cart && !redirectToCheckout) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message);
          }

          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }

          if (cart) {
            cart.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id);
              if (!elementToReplace || !response.sections || !response.sections[section.id]) return;
              const html = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
              const minicartForm = html.querySelector('#minicart-form');
              if (minicartForm) elementToReplace.innerHTML = minicartForm.innerHTML;
            });
            if (typeof cart.cartAction === 'function') cart.cartAction();
            if (typeof cart.open === 'function') cart.open();
          }

          fetch('/cart.js')
            .then((res) => res.json())
            .then((updatedCart) => {
              document.querySelectorAll('.cart-count').forEach((el) => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${updatedCart.item_count})`;
                } else {
                  el.innerHTML = updatedCart.item_count > 100 ? '~' : updatedCart.item_count;
                }
              });
              if (document.querySelector('header-total-price')) {
                document.querySelector('header-total-price').updateTotal(updatedCart);
              }
            });
        })
        .catch((error) => {
          console.error(error);
          this.showError(error.message || window.variantStrings?.soldOut || 'Something went wrong adding this to your cart.');
        })
        .finally(() => {
          if (redirectToCheckout) return;
          button.classList.remove('loading');
          button.disabled = false;
        });
    }
  }

  customElements.define('buy-more-save', BuyMoreSave);
}
